module.exports = __webpack_public_path__ + "img/siege_cruiser.e2fe4960.jpg";